import { render, staticRenderFns } from "./modifywarehouse.vue?vue&type=template&id=5fc337d1"
import script from "./modifywarehouse.vue?vue&type=script&lang=js"
export * from "./modifywarehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports